export const IssueRels = {
    GetExternalLink: 'issueExternalUrl'
};
